import { BlockComponentProps } from '../BlockComponent';

export default (
  props: BlockComponentProps,
  prevProps: BlockComponentProps,
): boolean => props.block.node!.changedAt! > prevProps.block.node!.changedAt!;
